import * as React from 'react';
import BreakpointWrapper from '@om-fe/core/components/breakpoint-wrapper/breakpoint-wrapper';
import LeftSideBar from '@om-fe/core/pages/theme1/parts/left-side-bar';
import ConnectionNotification from '@om-fe/core/components/notification/connection-notification';
import Header from '@om-fe/core/pages/theme1/parts/header';
import RightSideBar from '@om-fe/core/pages/theme1/parts/right-side-bar';
import TemplateContent, { BaseTemplatePublicProps } from '@om-fe/core/core/routing/templates/template-content';
import { bemContent } from '@om-fe/core/core/routing/templates/template.utils';
import { TemplateProps } from '@om-fe/core/template.models';
import { SearchPageComponent } from '@om-fe/core/pages/theme1/search-page';
import { compose } from 'redux';
import withTranslation from '@om-fe/core/core/i18n/with-translation';
import { RouteNames } from '@om-fe/core/core/routing/utils';
import FavoriteState from '@om-fe/core/components/favorite-button/favorite-state';
import FavoriteTournaments from '@om-fe/core/components/favorite-tournaments/favorite-tournaments';
import { Breakpoints } from '@om-fe/core/core/store/breakpoints';

class DefaultTemplateComponent extends React.PureComponent<TemplateProps> {
    render() {
        const { gettext } = this.props;

        return (
            <>
                <FavoriteState />
                <FavoriteTournaments />
                <BreakpointWrapper breakpoints={[Breakpoints.Large, Breakpoints.XL]}>
                    <span className={'SideBackground'}></span>
                    <LeftSideBar/>
                </BreakpointWrapper>
                <section className={bemContent({ extra: 'PageScrollableContent' })}>
                    <ConnectionNotification/>
                    <Header
                        defaultSearchMap={SearchPageComponent.defaultSearchMap}
                        searchPlaceholder={gettext('Search')}
                        searchRouteName={RouteNames.search}
                    />
                    <TemplateContent {...this.props}/>
                </section>
                <BreakpointWrapper breakpoints={[Breakpoints.Small]} action="hide">
                    <RightSideBar/>
                </BreakpointWrapper>
            </>
        );
    }
}

const DefaultTemplate = compose<React.ComponentClass<BaseTemplatePublicProps>>(
    withTranslation(),
)(DefaultTemplateComponent);
export default DefaultTemplate;
